<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-10-13 10:11:49
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\CustomForm\CustomForm\viewCustomForm.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-07 14:01:44
-->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_customForm_form_editTitle')
        : $t('label_essweb_customForm_form_viewTitle')
    "
    pad="0"
    :delBtn="hasBtn('delete-admin-custom-form-type')"
    widthClass="max-1000"
    :initData="customFormData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'application_type_name',
      'type_code',
      'application_type_desc',
      'flow_template_uuid',
      'color_code',
      'sequence',
    ]"
    :editBtn="!iSEdited && hasBtn('edit-admin-custom-form-type')"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_customForm_lsit_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber :curTab="curTab" @change="(tab) => (curTab = tab)" :items="taber">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-switch
                  color="primary"
                  class="ml-4"
                  :disabled="!iSEdited"
                  v-model="customFormData.status"
                  :label="
                    customFormData.status
                      ? $t('label_essweb_customForm_form_activeLabel')
                      : ''
                  "
                ></v-switch>
              </v-col>
              <v-col xs="12" sm="12" md="8" lg="8" cols="12">
                <inputTextFiledMultiLang
                  :bindData="customFormData.application_type_name"
                  maxlength="100"
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  @change="
                    (valueArr) => {
                      customFormData.application_type_name = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_customForm_form_customFormNameLabel')
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="4" lg="4" cols="12">
                <normalInputTextFiled
                  :label="
                    $t('label_essweb_customForm_form_customFormCodeLabel')
                  "
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  maxlength="100"
                  :rules="
                    $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
                  "
                  v-model="customFormData.type_code"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :bindData="customFormData.application_type_desc"
                  maxlength="100"
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  @change="
                    (valueArr) => {
                      customFormData.application_type_desc = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_customForm_form_customFormDescLabel')
                  "
                />
              </v-col>
              <v-col xs="12" sm="12" md="8" lg="8" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_customForm_form_customFormApprovalFlowLabel")
                }}</v-sheet>
                <v-autocomplete
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :items="approvalFlows"
                  :append-icon="iSEdited ? 'keyboard_arrow_down' : ''"
                  item-text="view_fields"
                  item-value="value_field"
                  single-line
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  v-model="customFormData.flow_template_uuid"
                  :label="
                    $t(
                      'label_essweb_customForm_form_customFormApprovalFlowLabel'
                    )
                  "
                  dense
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-autocomplete>
              </v-col>
              <v-col xs="12" sm="12" md="4" lg="4" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_customForm_form_colorLabel")
                }}</v-sheet>
                <SelectColor
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :items="$Colors"
                  v-model="customFormData.color_code"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <numberInputTextFiled
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :rules="
                    $GetRules(['_Number_negative', '_Length_Rules'], [null, 15])
                  "
                  v-model="customFormData.sequence"
                  :label="$t('label_essweb_customForm_form_sequenceLabel')"
                  isNotRequire
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_customForm_form_remarkLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  maxlength="500"
                  v-model="customFormData.remarks"
                  dense
                  counter="500"
                  single-line
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-container fluid class="mrc-grey rounded-lg">
            <v-sheet
              class="transparent d-flex pa-0 my-3 align-center"
              v-for="(item, index) in NoticeList"
              :key="index"
            >
              <v-hover v-slot:default="{ hover }" open-delay="100">
                <v-card
                  class="
                    white
                    d-flex
                    flex-row
                    justify-space-around
                    flex-grow-1
                    ml-3
                    pa-2
                    align-center
                  "
                  height="60"
                  :elevation="hover ? 10 : 2"
                >
                  <div style="width: 20px">
                    <svg-icon
                      size="24"
                      :fill="'black'"
                      iconClass="LabeledColour"
                    />
                  </div>
                  <span class="ml-2">
                    {{
                      $getCommonLangValue(
                        item["application_type_notice_point_" + item.number]
                      )
                    }}
                  </span>
                  <v-spacer></v-spacer>
                  <div>
                    <v-btn
                      icon
                      x-small
                      class="ma-2"
                      v-if="hover && iSEdited"
                      @click="toEditNotice(item)"
                    >
                      <span class="material-icons-round">edit</span>
                    </v-btn>
                    <v-btn
                      icon
                      class="ma-2"
                      v-if="hover && iSEdited"
                      @click="onDeleteNotice(item)"
                    >
                      <span class="material-icons-round">delete</span>
                    </v-btn>
                  </div>
                </v-card>
              </v-hover>
            </v-sheet>
          </v-container>
        </template>
        <template v-slot:content-3>
          <Tabler :headers="headers" :items="desserts" border :avPerPage="50">
            <template v-slot:item.sequence="{ item }">
              {{ item.sequence }}
            </template>
            <template v-slot:item.label="{ item }">
              {{ $getCommonLangValue(item.custom_field_name) }}
            </template>
            <template v-slot:item.type="{ item }">
              {{ $getCommonLangValue(item.custom_field_data_type_name) }}
            </template>
            <template v-slot:item.mandatory="{ item }">
              <span class="material-icons-round" v-if="Number(item.is_required)"
                >check</span
              >
              <span class="material-icons-round" v-else>close</span>
            </template>
            <template v-slot:item.action="{ item }">
              <div>
                <v-btn
                  icon
                  x-small
                  class="ma-2"
                  v-if="iSEdited"
                  @click="
                    curItemUuid = item.uuid;
                    showEditItem = true;
                  "
                >
                  <span class="material-icons-round">edit</span>
                </v-btn>
                <v-btn
                  icon
                  class="ma-2"
                  v-if="iSEdited"
                  @click="toDeleteItem(item.uuid)"
                >
                  <span class="material-icons-round">delete</span>
                </v-btn>
              </div>
            </template>
            <template v-slot:footer>
              <v-container fluid class="pa-0">
                <v-divider></v-divider>
                <v-btn
                  text
                  v-if="iSEdited"
                  small
                  class="my-2 text-capitalize"
                  color="primary"
                  @click="showNewItem = true"
                >
                  {{ $t("label_essweb_customForm_form_newItemLabel") }}
                  <span class="material-icons-round">add</span>
                </v-btn>
              </v-container>
            </template>
          </Tabler>
        </template>
      </Taber>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :saveBtn="curTab == 'tab-1'"
        v-if="iSEdited && curTab == 'tab-1'"
        @save="toSave"
        @cancel="toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <template v-slot:tools-main>
      <editNotice
        :show="showEditNotice"
        @close="
          showEditNotice = false;
          NoticePropertyData = null;
        "
        :PropertyData="NoticePropertyData"
        @onEdit="onEditNotice"
      />
      <newItem
        :show="showNewItem"
        @close="showNewItem = false"
        @onNew="onNewItem"
      />
      <editItem
        :show="showEditItem"
        :curUuid="curItemUuid"
        @close="
          showEditItem = false;
          curItemUuid = null;
        "
        @onEdit="onEditItem"
      />
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import editNotice from "@/Page/EssAdmin/CustomForm/CustomForm/components/editNotice";
import newItem from "@/Page/EssAdmin/CustomForm/CustomForm/components/newItem";
import editItem from "@/Page/EssAdmin/CustomForm/CustomForm/components/editItem";
export default {
  name: "editCustomForm",
  components: { editNotice, newItem, editItem },
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
    approvalFlows() {
      return this.$getSelectTrans(this.approvalFlowsData, "view_fields");
    },
  },
  data() {
    return {
      iSEdited: false,
      curTab: "tab-1",
      isChanged: false,
      showSelect: false,
      NoticeList: [],
      curItemUuid: null,
      showEditNotice: false,
      showNewItem: false,
      showEditItem: false,
      willClearNotice: null,
      approvalFlowsData: [],
      NoticePropertyData: null,
      taber: [
        "label_essweb_customForm_form_tab_InfoLabel",
        "label_essweb_customForm_form_tab_TermsLabel",
        "label_essweb_customForm_form_tab_ItemsLabel",
      ],
      customFormData: {
        status: 1,
        application_type_name: "",
        type_code: "",
        application_type_desc: "",
        flow_template_uuid: "",
        color_code: "",
        sequence: 1,
        application_type_notice_point_1: "",
        application_type_notice_point_2: "",
        application_type_notice_point_3: "",
        application_type_notice_point_4: "",
        application_type_notice_point_5: "",
      },
      headers: [
        {
          text: "label_essweb_customForm_form_list_item_sequenceLabel",
          value: "sequence",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_customForm_form_list_item_labelLabel",
          value: "label",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_customForm_form_list_item_typeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_customForm_form_list_item_isMandatoryLabel",
          value: "mandatory",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          sortable: false,
          align: "end",
        },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.NoticeList = [];
    for (let i = 0; i < 5; i++) {
      let json = {};
      json["application_type_notice_point_" + (i + 1)] =
        this.$transCommonLangKey(this.$getCommonLangKey(this.companyLang));

      json["number"] = i + 1;
      this.NoticeList.push(json);
    }
    this.getBtnPermissionList();
    this.getApprovalFlows();
    this.getDetail();
    this.getNotice();
    this.getItemsList();
  },
  methods: {
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            if (this.iSEdited) {
              this.iSEdited = false;
              this.getDetail();
            } else {
              this.$router.back();
            }
          }
        });
      else {
        if (this.iSEdited) {
          this.iSEdited = false;
          this.getDetail();
        } else {
          this.$router.back();
        }
      }
    },
    getApprovalFlows() {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_workflow_template_select",
      }).then((res) => {
        that.approvalFlowsData = res.data;
      });
    },
    toEditNotice: function (obj) {
      this.NoticePropertyData = obj;
      this.showEditNotice = true;
    },
    onDeleteNotice: function (item) {
      const that = this;
      this.willClearNotice = item;
      this.$confirmDo(
        this.$t("label_essweb_customForm_form_tab_TermsLabel")
      ).then((res) => {
        if (res) that.toClearNotice();
      });
    },
    toClearNotice: function () {
      const that = this;
      let data = {
        uuid: this.willClearNotice["uuid"],
      };
      data["application_type_notice_point_" + this.willClearNotice.number] =
        this.$transCommonLangKey(
          this.$getCommonLangKey(this.companyLang),
          this.willClearNotice[
            "application_type_notice_point_" +
              this.willClearNotice.number +
              "_save"
          ]
        );
      this.$Request({
        method: "POST",
        table: "ess_common_application_type_notice",
        url: "/common-application-type-notice/update/",
        data: data,
      }).then((res) => {
        that.NoticeList.map((item) => {
          if (item.number == that.willClearNotice.number) {
            item[
              "application_type_notice_point_" + that.willClearNotice.number
            ] =
              data[
                "application_type_notice_point_" + that.willClearNotice.number
              ];
          }
        });
      });
    },
    onEditNotice: function (obj, number) {
      const that = this;
      that.NoticePropertyData = null;
      let data = {
        uuid: obj.uuid,
      };
      data["application_type_notice_point_" + number] =
        obj["application_type_notice_point_" + number];
      this.showEditNotice = false;
      this.$Request({
        method: "POST",
        table: "ess_common_application_type_notice",
        url: "/common-application-type-notice/update/",
        data: data,
      }).then((res) => {
        that.NoticeList.map((item) => {
          if (item.number == number) {
            item["application_type_notice_point_" + number] =
              obj["application_type_notice_point_" + number];
          }
        });
      });
    },
    onNewItem: function (obj) {
      const that = this;
      this.showNewItem = false;
      this.$Request({
        method: "POST",
        table: "ess_common_application_type_custom_field",
        url: "/common-application-type-custom-field/add/",
        data: {
          custom_field_name: this.$transCommonLangKey(obj.custom_field_name),
          custom_field_placeholder: this.$transCommonLangKey(
            obj.custom_field_placeholder
          ),
          custom_field_data_type: obj.custom_field_data_type,
          is_required: obj.is_required ? 1 : 0,
          application_type_uuid: this.$route.params.id,
          sequence: obj.sequence,
          custom_field_data_layout: JSON.stringify(
            obj.custom_field_data_layout
          ),
        },
      }).then((res) => {
        that.getItemsList();
      });
    },
    onEditItem(obj) {
      const that = this;
      this.showEditItem = false;
      this.curItemUuid = null;
      this.$Request({
        method: "POST",
        table: "ess_common_application_type_custom_field",
        url: "/common-application-type-custom-field/update/",
        data: {
          uuid: obj.uuid,
          custom_field_name: this.$transCommonLangKey(
            obj.custom_field_name,
            obj.custom_field_name_save
          ),
          custom_field_placeholder: this.$transCommonLangKey(
            obj.custom_field_placeholder,
            obj.custom_field_placeholder_save
          ),
          custom_field_data_type: obj.custom_field_data_type,
          application_type_uuid: obj.application_type_uuid,
          custom_field_data_layout: JSON.stringify(
            obj.custom_field_data_layout
          ),
          sequence: obj.sequence,
          is_required: obj.is_required ? 1 : 0,
        },
      }).then((res) => {
        that.getItemsList();
      });
    },
    toDeleteItem(uuid) {
      const that = this;
      this.curItemUuid = uuid;
      this.$confirmDo(
        this.$t("label_essweb_customForm_form_tab_ItemsLabel")
      ).then((res) => {
        if (res) that.onDeleteItem();
      });
    },
    onDeleteItem: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_common_application_type_custom_field",
        url: "/common-application-type-custom-field/delete/",
        data: {
          uuids: this.curItemUuid,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_customForm_form_deletecustomFormItemSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter(
          (ele) => ele.uuid !== that.curItemUuid
        );
      });
    },
    toSave() {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_common_application_type",
        url: "/common-application-type/update/",
        data: {
          uuid: this.$route.params.id,
          type_code: this.customFormData.type_code,
          application_type_name: this.$transCommonLangKey(
            this.customFormData.application_type_name,
            this.customFormData.application_type_name_save
          ),
          application_type_desc: this.$transCommonLangKey(
            this.customFormData.application_type_desc,
            this.customFormData.application_type_desc_save
          ),
          status: this.customFormData.status ? 1 : 0,
          color_code: this.customFormData.color_code,
          sequence: this.customFormData.sequence,
          flow_template_uuid: this.customFormData.flow_template_uuid,
          remarks: this.customFormData.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_customForm_form_updateCustomFormSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    getItemsList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_common_application_type_custom_field",
        url: "/common-application-type-custom-field/get-list/",
        data: {
          application_type_uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.desserts.map((item) => {
          let layout = that.$iSJson(item["custom_field_data_layout"]);
          item["custom_field_data_layout"] = layout
            ? layout
            : { xs: 12, sm: 12, md: 6, lg: 6, xl: 4, cols: 12 };
        });
        that.desserts = res.data;
      });
    },
    getNotice: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_common_application_type_notice",
        url: "/common-application-type-notice/get-list/",
        data: {
          application_type_uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data[1] = JSON.parse(JSON.stringify(res.data[0]));
        res.data[2] = JSON.parse(JSON.stringify(res.data[0]));
        res.data[3] = JSON.parse(JSON.stringify(res.data[0]));
        res.data[4] = JSON.parse(JSON.stringify(res.data[0]));

        res.data[0]["number"] = 1;
        res.data[1]["number"] = 2;
        res.data[2]["number"] = 3;
        res.data[3]["number"] = 4;
        res.data[4]["number"] = 5;
        res.data.map((item, index) => {
          item["application_type_notice_point_" + (index + 1) + "_save"] =
            item["application_type_notice_point_" + (index + 1)];
        });

        that.NoticeList = res.data;
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_common_application_type",
        url: "/common-application-type/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["application_type_name_save"] = res.data.application_type_name;
        res.data.application_type_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.application_type_name
        );
        res.data["application_type_desc_save"] = res.data.application_type_desc;
        res.data.application_type_desc = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.application_type_desc
        );
        this.customFormData = res.data;
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_common_application_type",
        url: "/common-application-type/delete/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_customForm_list_deleteCustomFormSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
  },
};
</script>